import { BOOKING_URL } from "@/components/CoachInvite";

export const ASSESSMENT_URL = "www.MinistersHelper.com/free";

export const ResourceNotice = ({ showQr = false }) => {
  const year = new Date().getFullYear();
  return (
    <div className="avoid-break mt-6 border-t border-slate-300 pt-4 text-[11px] leading-relaxed text-slate-600" data-testid="resource-notice">
      <div className="flex items-start gap-4">
        <div className="flex-1 space-y-1">
          <p className="font-semibold text-slate-800">
            For paid clients, book purchasers and workshop attendees only. No copying or distribution of this resource is allowed.
          </p>
          <p data-testid="resource-copyright">
            © {year} Minister's Helper LLC. All rights reserved. Questions or permission requests: hello@ministershelper.com
          </p>
          <p>Take the assessment online: <span className="font-semibold text-[#1F4266]">{ASSESSMENT_URL}</span></p>
        </div>
        {showQr && (
          <div className="flex items-center gap-2" data-testid="resource-qr-block">
            <img src="/schedule-qr.png" alt="QR code to schedule a coaching call" className="h-16 w-16" />
            <div className="max-w-[170px]">
              <div className="font-semibold text-slate-800">Want one-on-one coaching support?</div>
              <div className="break-all">{BOOKING_URL}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export const PrintBar = ({ title }) => (
  <div className="no-print mb-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
    <span>Admin-only printable: {title}</span>
    <button type="button" data-testid="print-resource-button" onClick={() => window.print()} className="rounded-full bg-[#1F4266] px-4 py-1.5 font-medium text-white hover:bg-[#16324f]">
      Print / Save as PDF
    </button>
  </div>
);
